import React, { useState } from 'react'
import {HiMenuAlt4, HiX} from 'react-icons/hi'
import { images } from '../../constants'
import {motion} from 'framer-motion'
import './navbar.scss'

const Navbar = () => {
  const [toggle, setToggle ] = useState(false)
  const navLink = ['home','about','work','skills','contact']

  const handleToggle = () => {
    setToggle(!toggle)
  }

  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <a href='/'>
        <h2>FADAHUNSI</h2>
        </a>
      </div>
      <ul className='app__navbar-links'>
        {navLink.map((item)=>(
          <li className='app__flex' key={`link-${item}`} >
            <div/>
            <a href= {`#${item}`}> {item} </a>
          </li>
        ))}
      </ul>
      <div className='download'>
        <a href="https://docs.google.com/document/d/1_03ql83DWtGvFLsz7xIh6KRyOfbIIJ8Y3-jDbskKo_s/edit?usp=sharing">Resume</a>
      </div>
      <div className='app__navbar-menu'>
        <HiMenuAlt4 onClick={handleToggle} />
        {toggle &&(
          <motion.div
          whileInView={{x: [300,0]}}
          transition={{duration: 0.88,ease:'easeOut'}}
          >
            <HiX onClick={handleToggle} />
          <ul>
            {navLink.map((item)=>(
          <li key={item}>
            <a href= {`#${item}`} onClick={handleToggle} > {item} </a>
          </li>
        ))}
        </ul>
          </motion.div>
        )}
      </div>
    </nav>
  )
}

export default Navbar
